(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["catpak-free-shipping-bar"] && !Shopify.designMode) return;
  try {
    class CatpakFreeShipping extends HTMLElement {
    connectedCallback() {
      this.threshold = parseInt(this.dataset.threshold, 10) || 50000;
      this.moneyFormat = this.dataset.moneyFormat || '';
      this.remainingTpl = this.dataset.remainingTpl || '';
      this.unlockedText = this.dataset.unlockedText || '';
      this.msgEl = this.querySelector('.catpak-ship__msg');
      this.fillEl = this.querySelector('.catpak-ship__fill');

      // Globally hook fetch once: any cart-changing request -> broadcast event.
      if (!window.__catpakFSHook) {
        window.__catpakFSHook = true;
        const orig = window.fetch;
        window.fetch = function (...args) {
          const promise = orig.apply(this, args);
          let url = args[0];
          url = url && url.url ? url.url : url;
          if (typeof url === 'string' && /\/cart\/(change|add|update|clear)/i.test(url)) {
            promise.then(function () {
              setTimeout(function () {
                document.dispatchEvent(new CustomEvent('catpak:cart-changed'));
              }, 50);
            });
          }
          return promise;
        };
      }

      this._handler = this.refresh.bind(this);
      document.addEventListener('catpak:cart-changed', this._handler);
    }

    disconnectedCallback() {
      document.removeEventListener('catpak:cart-changed', this._handler);
    }

    async refresh() {
      try {
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const res = await fetch(root + 'cart.js');
        const cart = await res.json();
        this.render(cart.total_price);
      } catch (e) { /* noop */ }
    }

    render(total) {
      const remaining = this.threshold - total;
      const pct = Math.min(100, (total / this.threshold) * 100);
      this.fillEl.style.width = pct + '%';
      if (remaining > 0) {
        this.classList.remove('is-unlocked');
        this.msgEl.textContent = this.remainingTpl.replace('__AMT__', this.formatMoney(remaining));
      } else {
        this.classList.add('is-unlocked');
        this.msgEl.textContent = this.unlockedText;
      }
    }

    formatMoney(cents) {
      const amount = cents / 100;
      function group(num, sep) {
        return num.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + sep);
      }
      const fmt = this.moneyFormat;
      const match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
      let str;
      switch (match ? match[1] : 'amount') {
        case 'amount_no_decimals': str = group(Math.round(amount).toString(), ','); break;
        case 'amount_with_comma_separator': str = group(amount.toFixed(2), '.').replace(/\.(\d{2})$/, ',$1'); break;
        case 'amount_no_decimals_with_comma_separator': str = group(Math.round(amount).toString(), '.'); break;
        default: str = group(amount.toFixed(2), ',');
      }
      return match ? fmt.replace(/\{\{\s*\w+\s*\}\}/, str) : ('$' + str);
    }
  }
  if (!customElements.get('catpak-free-shipping')) {
    customElements.define('catpak-free-shipping', CatpakFreeShipping);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["catpak-sticky-atc"] && !Shopify.designMode) return;
  try {
    class CatpakStickyAtc extends HTMLElement {
    connectedCallback() {
      this.mainBtn = document.querySelector('.product-form__submit');
      this.btn = this.querySelector('.catpak-sticky-atc__btn');
      if (!this.mainBtn) return;

      this.btn.addEventListener('click', () => this.mainBtn.click());

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const show = !entry.isIntersecting;
          this.classList.toggle('is-visible', show);
          this.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      }, { threshold: 0 });
      this.observer.observe(this.mainBtn);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }
  customElements.define('catpak-sticky-atc', CatpakStickyAtc);
  } catch(e) { console.error(e); }
})();

})();
